import utils from '../../Functions/utils';
import HeaderComp from '../Header/Header';
import './HomePage.css';
import { useState, useEffect } from 'react';
import { HDate } from '@hebcal/core';
import { getFormattedDate } from '../../Functions/getFormattedDate';


function HomePageComp(props) {
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const [userData, setuserData] = useState({});
  const [completedDays, setCompletedDays] = useState([]);
  const [hebDate, setHebDate] = useState('');
  const [hebDay, setHebDay] = useState('');
  const [error, setError] = useState('');
  const [sunrise, setSunrise] = useState('');
  const [sunset, setSunset] = useState('');
  const [cityName, setCityName] = useState('');
  const [lizchus, setLizchus] = useState('');
  const [dailyBooks, setDailyBooks] = useState([]);



  useEffect(() => {
    const fetchData = async () => {
      await fetchDailyBooks();
      // await fetchSunrise();
      await fetchLizchus("lizchus");
    };
    fetchData();
  }, []);

  
  const fetchLizchus = async (name) => {
    const localKey = 'lizchus';
    try {
      const cached = localStorage.getItem(localKey);
      if (cached) {
        setLizchus(cached);
      } else {
         const resp = await utils.requestData('GetConfigurationByName', {name});
        setLizchus(resp[0].value);
        localStorage.setItem(localKey, resp[0].value);
      }
    } catch (err) {
      console.error('Error fetching DailyBooks:', err);
      setError(err.message);
    }
  };

  const fetchDailyBooks = async () => {
    const localKey = 'dailyBooks';
    try {
      const cached = localStorage.getItem(localKey);
      if (cached) {
        setDailyBooks(JSON.parse(cached));
        // console.log(cached)
      } else {
        const resp = await utils.requestData('GetDailyBooks', {});
        // console.log(resp)
        // if (resp[0].code !== 90) throw new Error(resp[0].msg);
        setDailyBooks(resp);
        localStorage.setItem(localKey, JSON.stringify(resp));
      }
    } catch (err) {
      console.error('Error fetching DailyBooks:', err);
      setError(err.message);
    }
  };

  useEffect(() => {

    function convertToHebrewDate() {
      const hDate = new HDate(props.d);
      return hDate.renderGematriya(true);
    }
    setHebDate(convertToHebrewDate())

    const day = props.d.getDay() + 1
    switch (day) {
      case 1:
        setHebDay("יום ראשון")
        break;
      case 2:
        setHebDay("יום שני")
        break;
      case 3:
        setHebDay("יום שלישי")
        break;
      case 4:
        setHebDay("יום רביעי")
        break;
      case 5:
        setHebDay("יום חמישי")
        break;
      case 6:
        setHebDay("יום שישי")
        break;
      case 7:
        setHebDay("שבת קודש")
        break;

      default:
        break;
    }

  }, [])

  useEffect(() => {

    const getuserData = async () => {
      const localKey = 'userData';

      try {
        const cached = localStorage.getItem(localKey);

        // console.log(cached)
        if (cached) {
          // console.log("01")
          const parsed = JSON.parse(cached);
          setuserData(parsed);
        } else {
          console.log("02")
          let resp = await utils.requestData("GetUserData", {});

          if (resp[0].code !== 90) {
            setuserData(resp[0]);
            localStorage.setItem(localKey, JSON.stringify(resp[0]));
          } else {
            setError(resp[0].msg);
          }
        }
      } catch (error) {
        console.error("Error fetching userData:", error);
        setLoading(false);
      }
    };

    const getCaptureCompleted = async () => {
      try {
        let resp = await utils.requestData("GetUserCompletedChapters", {
          dayOf: getFormattedDate()
        });

        if (resp[0].code !== 90) {
          const parsed = JSON.parse(resp[0].chapterListJson);
          if (parsed && parsed.length > 0) {
            const chapterArray = parsed.map(c => c.chapterId);
            const uniqueChapters = [...new Set(chapterArray)];
            setCompletedDays(uniqueChapters);
          }
        } else {
          setError(resp[0].msg);
        }

      } catch (error) {
        console.error("Error fetching teamsData:", error);
        setLoading(false);
      }
    };

    getuserData().finally(() => getCaptureCompleted());

  }, [])

  const handleNext = () => {
    // console.log("handleNext")
    props.sdo(1);
  };

  const handlePrev = () => {
    // console.log("handlePrev")
    props.sdo(-1);
  };


  return (

    <div className="tanya-container">

      <HeaderComp
        userData={userData}
        menuHeaderOpen={menuHeaderOpen}
        setMenuHeaderOpen={setMenuHeaderOpen}
      />

      <button className="mobile-menu-toggle" onClick={() => props.open(!props.menuOpen)}>
        ☰ קטגוריות
      </button>

      <div className="day-navigation">
        <button className="font-btn" onClick={handlePrev}>➡</button>
        <h4>{hebDay}, {hebDate}</h4>
        <button className="font-btn" onClick={handleNext}>⬅</button>
      </div>


      <div className="item-grid">
        {dailyBooks.length > 0 && dailyBooks.map((item, index) => {
          const token = localStorage.getItem("auth-token");

          // תנאי לסינון פריט מסוים
          if (item.key === "00108" && token !== "7AA8660F-254D-436A-95AC-8527A531BAEB") {
            return null; // אל תציג את הפריט הזה
          }

          return (
            <div
              key={index}
              className={completedDays.includes(item.key) ? "item-button-completed" : "item-button"}
              onClick={() => props.selectedDay(item.key)}
            >
              {completedDays.includes(item.key) && '✓ '}
              {item.value}
            </div>
          );
        })}
      </div>


      {
        // (sunrise !== '' || sunset !== '' || cityName !== '') &&
        // <div className="centered-container">
        //   <p>
        //     <strong>זריחה:</strong> {sunrise} <strong>שקיעה:</strong> {sunset}<br />
        //     {/* הזמנים לפי מיקום {cityName} */}
        //   </p>
        // </div>
      }



      {/* {completedDays.join(',')} */}

      {/* <h4 className="dedication-box">
        לזכות <br />
        אברהם דוד בן יוכבד<br />
      </h4> */}

      <h4 className="dedication-box">{lizchus}</h4>

      {/* <h4 className="dedication-box">
        לע"נ <br />
        מרת פייגה צפורה בת ר' יצחק יונה ע"ה <br />
      </h4> */}
    </div>
  );

}


export default HomePageComp;